// extracted by mini-css-extract-plugin
module.exports = {"main":"main___V9SJt","wide":"wide___26_PS"};